import { Modal } from "react-bootstrap";
import { AddCommentModalProps } from "./comments.types";
import { Button } from "../button";
import { GenericForm } from "../generic-form";

export function AddCommentModal({
  show,
  onCancel,
  onSubmit,
  taskAddCommentForm,
  addingComment,
}: AddCommentModalProps) {
  return (
    <Modal show={show} animation onHide={onCancel}>
      <Modal.Header>
        <h5 className="modal-title" id="Dismiss Modal">
          Add comment
        </h5>
        <div onClick={onCancel}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <GenericForm
          form={taskAddCommentForm}
          onSubmit={onSubmit}
          submitControl={(submit) => (
            <div className="flex-row">
              <Button
                isLoading={addingComment}
                loader={{ size: "s" }}
                className="btn btn-primary mt-3 w-100"
                type="submit"
              >
                Send comment
              </Button>
            </div>
          )}
        />
      </Modal.Body>
    </Modal>
  );
}
